export default class ConnectionConstants {
    static LOADING = 0;
    static SUCCESS = 1;
    static ERROR = 2;
}